import { render } from "./mov-pdv-editar.vue?vue&type=template&id=8bc1a2d6"
import script from "./mov-pdv-editar.vue?vue&type=script&lang=js"
export * from "./mov-pdv-editar.vue?vue&type=script&lang=js"

import "./mov-pdv-editar.vue?vue&type=style&index=0&id=8bc1a2d6&lang=css"

import exportComponent from "C:\\Users\\Administrador\\PhpstormProjects\\mtex_mobagile_m3_front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__